import { render, staticRenderFns } from "./pointRecord.vue?vue&type=template&id=01dbf462&scoped=true"
import script from "./pointRecord.vue?vue&type=script&lang=js"
export * from "./pointRecord.vue?vue&type=script&lang=js"
import style0 from "./pointRecord.vue?vue&type=style&index=0&id=01dbf462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dbf462",
  null
  
)

export default component.exports